module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAALpJREFUSA1jXMcr+J8BDTCh8cFcrIKMNNCOzXLGnz9/YjgTq0JsDiJbIVY/o5tGlCKiPIA1NMmzjthgQDcdG58oD2LTiE2MqIDAphGbGONucyuikgU2zehiLJ+vXUcXI5tP3TAbtLFJVW8OXsOommip6s0RkgOoGmZUNYyoMpvsYoQCjVT1JQXuwNA66jCMICEgwCITFUFAycBIU7VcpKYXBm0aGy0uSI3mQRuVg9ZhLHx6uqSGMl3UAwAWOTCfbQZkIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/Latvia.png
// module id = 504
// module chunks = 7